<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="custom-header-title float-left pr-1 mb-0">
              Sales Submissions (Changi)
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          />

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refChangiSubmissionsTable"
        class="position-relative min-height-table"
        :items="itemListData"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'ChangiSalesSubmission')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'sales-changi-submissions-show', params: { id: data.item._id } }"
            >
              {{ data.item.stringID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.stringID }}
            </b-button>
          </div>
        </template>

        <template #cell(agent)="data">
          <div
            v-if="data.item.agent"
            class=""
          >
            <b-button
              v-if="canViewThisAction('show', 'Agent')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id text-uppercase"
              :to="{ name: 'agency-agents-show', params: { id: data.item.agent } }"
            >
              {{ data.item.agentName }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle not-button text-uppercase"
            >
              {{ data.item.agentName }}
            </b-button>
            <br>
            <span
              v-if="data.item.agentCode"
              class=""
            >
              {{ data.item.agentCode }}
            </span>
          </div>
          <span v-else>––</span>
        </template>

        <template #cell(lot)="data">
          <div class="text-nowrap">
            <span class="text-bold-black">{{ data.item.zoneLotNo }}</span>
            <br>
            <span class="">{{ data.item.productType }}</span>
          </div>
        </template>

        <template #cell(orderTotal)="data">
          <div class="text-nowrap">
            <span class="text-bold-black">${{ numberFormat(data.item.orderTotal) }}</span>
          </div>
        </template>

        <template #cell(payableAmount)="data">
          <div class="text-nowrap">
            <span class="text-bold-black">${{ numberFormat(data.item.payableAmount) }}</span>
            <br>
            <span class="">{{ getPaymentOption(data.item.paymentOption) }}</span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'ChangiSalesSubmission')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'ChangiSalesSubmission')"
              :to="{ name: 'sales-changi-submissions-show', params: { id: data.item._id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalSubmissions > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalSubmissions"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
// eslint-disable-next-line import/no-cycle
import useSubmissionList from './useSubmissionList'
import submissionStoreModule from './submissionStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/placeholder/placeholder_image.png'),
      statusOptions: [
        { title: 'Published', code: 'published' },
        { title: 'Draft', code: 'draft' },
      ],
    }
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_locations.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_locations.show(true)
    },
    removeFromStatusFilter(category) {
      const index = this.statusFilter.indexOf(category)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    clearAllFilters() {
      this.statusFilter = []
      this.createdAtFilter = ''
    },
    getPaymentOption(option) {
      if (option === 'bookingfee') return 'Booking fee'
      if (option === 'downpayment') return 'Downpayment'
      if (option === 'fullpayment') return 'Full payment'
      return '-'
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const CHANGI_SUBMISSION_APP_STORE_MODULE_NAME = 'app-changi-submissions'

    // Register module
    if (!store.hasModule(CHANGI_SUBMISSION_APP_STORE_MODULE_NAME)) store.registerModule(CHANGI_SUBMISSION_APP_STORE_MODULE_NAME, submissionStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHANGI_SUBMISSION_APP_STORE_MODULE_NAME)) store.unregisterModule(CHANGI_SUBMISSION_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchSubmissions,
      tableColumns,
      perPage,
      currentPage,
      totalSubmissions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refChangiSubmissionsTable,
      refetchData,
      currentDataLength,
      itemListData,

      // UI
      resolveStatusVariant,

      // Extra Filters
      statusFilter,
      createdAtFilter,
    } = useSubmissionList()

    if (searchQuery.value) {
      showSearchBar.value = true
    }

    return {
      // Sidebar
      fetchSubmissions,
      tableColumns,
      perPage,
      currentPage,
      totalSubmissions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refChangiSubmissionsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      currentDataLength,
      itemListData,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveStatusVariant,

      // Extra Filters
      statusFilter,
      createdAtFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.img-preview-block{
      box-sizing: border-box;
      width: 38px;
      height: 38px;
      border: 1px solid #D2DCEA;
      border-radius: 5px;
  }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
